import {Button, Spinner} from "react-bootstrap";
import React from "react";
import {useTranslation} from "react-i18next";

interface IButtonSpinnerProps {
    title: string;
    isLoading?: boolean;
    onClick?: () => void;
    isDisabled?: boolean;
}

export const ButtonSpinner: React.FC<IButtonSpinnerProps> = ({isLoading, title, onClick, isDisabled}) => {
    const {t} = useTranslation();
    return (
        <Button variant="secondary" disabled={isDisabled || isLoading} onClick={onClick}>
            {isLoading ? (
                <>
                    <Spinner as="span" animation="border" size="sm" role="status"
                             aria-hidden="true"/>
                    {' '}{t("DropZone.loading")}
                </>
            ) : (title)}
        </Button>
    )
}
